/**
 * The legend's glyph of a point layer drawn as a symbol (fires, hot spots, towers, direction arrows; `@teslyn/domain` map-symbols.ts,
 * R143 and R149), in its colour token, the same shape the map draws.
 */
import type { ReactElement } from 'react';
import { SYMBOL_DRAWINGS, SYMBOL_EDGE_INK, type MapSymbol } from '@teslyn/domain';

export function SymbolGlyph({
  symbol,
  colour,
}: {
  readonly symbol: MapSymbol;
  readonly colour: string;
}): ReactElement {
  const d = SYMBOL_DRAWINGS[symbol];
  const c = `var(--${colour})`;
  // a direction arrow is edged dark as the lines it sits on (decision 1011), every other symbol white
  const edge = symbol === 'arrow' ? 'var(--map-line-casing)' : SYMBOL_EDGE_INK;
  return (
    <svg className={`legend__symbol legend__symbol--${symbol}`} viewBox={d.viewBox} aria-hidden="true">
      {d.strokes.map((p) => (
        <path
          key={`h${p}`}
          d={p}
          fill="none"
          stroke={SYMBOL_EDGE_INK}
          strokeWidth="3.6"
          strokeLinecap="round"
        />
      ))}
      {d.strokes.map((p) => (
        <path key={p} d={p} fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" />
      ))}
      {d.fill.map((p) => (
        <path key={p} d={p} fill={c} stroke={edge} strokeWidth="1.2" strokeLinejoin="round" />
      ))}
    </svg>
  );
}
